import { render, staticRenderFns } from "./CHeader.vue?vue&type=template&id=87d12c1e&scoped=true&"
import script from "./CHeader.vue?vue&type=script&lang=js&"
export * from "./CHeader.vue?vue&type=script&lang=js&"
import style0 from "./CHeader.vue?vue&type=style&index=0&id=87d12c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d12c1e",
  null
  
)

export default component.exports